/* eslint-disable react/jsx-no-target-blank */
import React, { useContext } from 'react';
import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { MainContext } from '../../context';
import {
  checkIfUrlHasSameDomain,
  shouldUseStandardAnchor,
  sanitizeUrlForExternalLink,
  hasRelationship
} from './helpers';
import getAriaLabel from './helpers/get-aria-label';

const Link = ({
  children,
  href,
  className,
  shallow,
  scroll,
  onClick,
  ariaLabel,
  name,
  ...props
}) => {
  const { fullUrl } = useContext(MainContext);
  const { host: currentDomain } = fullUrl ? new URL(fullUrl) : {};
  const sanitizedUrl = sanitizeUrlForExternalLink(href);
  const isSameDomain = checkIfUrlHasSameDomain(currentDomain, href);

  const computedAriaLabel = getAriaLabel({ ariaLabel, name, children, href });

  return shouldUseStandardAnchor(href) ? (
    <a
      aria-label={computedAriaLabel}
      href={sanitizedUrl}
      rel={hasRelationship(sanitizedUrl, isSameDomain)}
      target={isSameDomain ? '' : '_blank'}
      className={className}
      {...props}>
      {children}
    </a>
  ) : (
    // href should be /Resolver as blaze urls are dynamic so rendering is handled by the blaze nextjs page /Resolver
    // nextjs will render the link with the href set in the child <a> and route using "as"
    <NextLink
      href="/Resolver"
      shallow={shallow}
      scroll={scroll}
      as={href}
      aria-label={computedAriaLabel}
      className={className}
      onClick={onClick}
      {...props}>
      {children}
    </NextLink>
  );
};

Link.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  name: PropTypes.string,
  ariaLabel: PropTypes.string,
  shallow: PropTypes.bool,
  scroll: PropTypes.bool,
  onClick: PropTypes.func
};

Link.defaultProps = {
  children: null,
  className: null,
  ariaLabel: '',
  shallow: false,
  scroll: null,
  onClick: null,
  name: ''
};

export default Link;
